import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  assets: hasMany('asset', { inverse: 'assetTokenConfigs' }),
});
